import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson2DefaultStartCode = `// Destructure the \`cat\` tuple to call print on each member.

use debug::PrintTrait;

fn main() {
    let cat = ('Furry McFurson', 3);
    ${doNotModifyCodeAbove}`;

export const lesson2DefaultMiddleCode = `    //TODO: Fix me to make the code compile
    let`;

export const lesson2DefaultEndCode = `    ${doNotModifyCodeBelow} 
    name.print();
    age.print();
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
